import {Text} from '@dropbox/dig-components/typography';
import {atoms, Box} from '@dropbox/dig-foundations';
import {Link} from 'components/DSYS/Link';
import {ReactNode} from 'react';

import {type ChatMention, splitMentions} from './chatMentions';

export type ChatUserBubbleProps = {
  children: ReactNode;
  maxWidth?: string;
  /** People @mentioned in a string `children`, shown as links to their profiles. */
  mentions?: ChatMention[];
};

const renderText = (text: string, mentions?: ChatMention[]) =>
  mentions?.length
    ? splitMentions(text, mentions).map((part, i) =>
        typeof part === 'string' ? (
          part
        ) : (
          <Link key={i} to={`/people/${part.ldap}`} hasNoUnderline style={{fontSize: 'inherit'}}>
            @{part.name}
          </Link>
        )
      )
    : text;

export const ChatUserBubble = ({children, maxWidth = '60%', mentions}: ChatUserBubbleProps) => (
  <Box display="flex" style={{justifyContent: 'flex-end'}}>
    <Box
      padding="12"
      borderRadius="Large"
      className={atoms({backgroundColor: 'Secondary Surface'})}
      style={{maxWidth}}
    >
      {typeof children === 'string' ? (
        <Text style={{whiteSpace: 'pre-wrap', overflowWrap: 'anywhere'}}>
          {renderText(children, mentions)}
        </Text>
      ) : (
        children
      )}
    </Box>
  </Box>
);
